<!-- @format -->

<ng-container *transloco="let t">
  @if (attainment | attainmentName | async | localizedString; as attainmentName) {
    <div class="modal-header">
      <h2 id="attainment-details-heading">{{ attainmentName }}, {{ attainment | attainmentCode | async }}</h2>
      <button type="button" class="modal-close" (click)="modal.close()" [attr.aria-label]="t('ARIA_LABEL.CLOSE')">
        <sis-icon icon="ring-close"></sis-icon>
      </button>
    </div>
    <div class="modal-body">
      @if (attainment.type === "CourseUnitAttainment") {
        <app-course-unit-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent"
          [gradeRaiseEnabled]="gradeRaiseEnabled"
          [gradeRaiseInfoEnabled]="gradeRaiseInfoEnabled"
          [gradeRaiseAttempt]="gradeRaiseAttempt"
          [isAttachedToPrimaryAttainment]="isAttachedToPrimaryAttainment"
          [modalRef]="this.modal">
        </app-course-unit-attainment-details>
      }
      @if (attainment.type === "DegreeProgrammeAttainment") {
        <app-degree-programme-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </app-degree-programme-attainment-details>
      }
      @if (attainment.type === "ModuleAttainment") {
        <app-module-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </app-module-attainment-details>
      }
      @if (attainment.type === "CustomModuleAttainment") {
        <app-custom-module-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </app-custom-module-attainment-details>
      }
      @if (attainment.type === "AssessmentItemAttainment") {
        <app-assessment-item-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </app-assessment-item-attainment-details>
      }
      @if (attainment.type === "CustomCourseUnitAttainment") {
        <app-custom-course-unit-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </app-custom-course-unit-attainment-details>
      }
    </div>
    <div class="modal-footer">
      <sis-button (clicked)="modal.dismiss()">{{ t("COMMON.CLOSE") }}</sis-button>
    </div>
  }
</ng-container>
